import { inject } from '@angular/core';
import { BusinessService } from '../../services/business';
import { AuthService } from '../../services/auth';
import { PreloaderService } from '../services/preloader.service';
import { ToastService } from '../services';

export abstract class CreatesByBusiness<R, U> {
  protected abstract endpoint: string;

  protected businessService = inject(BusinessService);
  protected authService = inject(AuthService);
  protected preloader = inject(PreloaderService);
  protected toastService = inject(ToastService);
  open = false;
  isSaving = false;

  protected get businessId(): string {
    const id = this.authService.getUserInfo()?.business_id;
    if (!id) throw new Error('business_id no disponible todavía');
    return id;
  }

  protected afterCreate(_res: R): void {}
  protected afterDelete(): void {}
  protected afterUpdate(): void {}

  protected onCreateError(err: unknown): void {
    console.error(err);
    const apiError = (err as any)?.error;
    const errors = Array.isArray(apiError?.errors) ? apiError.errors : null;
    const serverMessage =
      apiError?.message ||
      apiError?.Message ||
      (typeof apiError === 'string' ? apiError : null);

    const pickError = (): string | null => {
      if (errors && errors.length) {
        const relevant =
          errors.find((e: string) => !e.toLowerCase().includes('error interno del servidor')) ||
          errors[0];
        return this.cleanValidationMessage(relevant);
      }
      if (serverMessage) return this.cleanValidationMessage(serverMessage);
      return null;
    };

    const message =
      pickError() ||
      this.cleanValidationMessage((err as any)?.message) ||
      'No pudimos procesar la solicitud. Intenta nuevamente.';
    this.toastService.show(message, 'warning', 6000);
  }

  private cleanValidationMessage(message?: string): string {
    if (!message) return '';
    const parts = message.split('\n').map((p) => p.trim()).filter(Boolean);
    const candidate = parts.length > 1 ? parts[parts.length - 1] : parts[0];
    const withoutValidation = candidate.replace(/^Validation failed:\s*/i, '');
    const withoutSeverity = withoutValidation.replace(/Severity:\s*Error/i, '').trim();
    const colonIndex = withoutSeverity.lastIndexOf(':');
    if (colonIndex !== -1 && colonIndex + 1 < withoutSeverity.length) {
      return withoutSeverity.slice(colonIndex + 1).trim();
    }
    return withoutSeverity;
  }

  protected deleteRecordById(entityId: string) {
    this.businessService
      .deleteRecordByBusinessId(this.businessId, entityId, this.endpoint)
      .subscribe({
        next: (res) => {
          if (res) {
            this.afterDelete();
          }
        },
        error: (err) => this.onCreateError(err),
      });
  }

  onModalConfirm(payload: R | any): void {
    if (!payload) {
      this.open = false;
      return;
    }
    if (!payload.entityId) {
      this.isSaving = true;
      this.businessService
        .createRecordByBusinessId<R>(this.businessId, payload, this.endpoint)
        .subscribe({
          next: (res) => {
            this.isSaving = false;
            this.open = false;
            this.afterCreate(res as R);
          },
          error: (err) => {
            this.isSaving = false;
            this.onCreateError(err);
          },
        });
    } else {
      this.isSaving = true;
      this.businessService
        .updateRecordByBusinessId<U>(
          this.businessId,
          payload.entityId,
          payload,
          this.endpoint
        )
        .subscribe({
          next: (res) => {
            this.isSaving = false;
            this.afterUpdate();
          },
          error: (err) => {
            this.isSaving = false;
            this.onCreateError(err);
          },
        });
    }
  }
}
